import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const MyExpense = lazy(() => import("@/pages/MyExpense/MyExpense"));

const baseUrl = "app.fieldforceconnect.com";

const MyExpenseRoute: RouteConfig = {
  path: "/MyExpense",
  element: <MyExpense />,
  pageName: "My Expense",
  sidebar: {
    show: true,
    icon:
      baseUrl === window.location.href.split("/")[2]
        ? "/assets/media/expenseLogo.svg"
        : "/assets/media/dollar.svg",
  },
  permission: ["ExpenseView"],
};

export default MyExpenseRoute;
